import { IEvents } from "@walletconnect/jsonrpc-types";
export class IState extends IEvents {
    constructor(client, logger, name) {
        super();
        this.client = client;
        this.logger = logger;
        this.name = name;
    }
}
//# sourceMappingURL=state.js.map